import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { getReportLists } from '../services/reportlist/function';
import { reportListKeys } from '../services/reportlist/key';
import { localStateKeys } from '../utils/reportviewutils';

function ReportList() {
  const { status : status, data : data, error: error } = useQuery({
    queryKey: reportListKeys.all,
    queryFn: getReportLists,
    staleTime: Infinity,
    meta: { numReports : 50, numPatients : 10 },
  });

  const { data : maxStudies } = useQuery({
    queryKey: localStateKeys.maxBlocks,
    queryFn: async () : Promise<number> => {
      return Promise.resolve(100);
    },
    staleTime: Infinity,
  });  

  const mutation = useMutation({
    mutationFn: (input : number) => Promise.resolve(input),
    onSuccess: (data) => {
      queryClient.setQueryData(
        localStateKeys.maxBlocks, data
      )
    },
  });


  // event handler 
  const queryClient = useQueryClient();
  const handleTestButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    queryClient.invalidateQueries({queryKey: reportListKeys.all});
    event.preventDefault();
    return false;
  }

  const handleNumStdChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    mutation.mutate(Number(event.currentTarget.value));
    return false;
  }

  // if (isPending) 
  if (status === 'pending') {
    return <span>Loading...</span>
  }

  // if (isError) 
  if (status === 'error') {
    return <span>Error: {error.message}</span>
  }

  return (
    <>
      { 
        (() => {
          console.log('report list page is now rendering...');
          return null;
        })() && undefined
      }
      <h2>Report List Test Page</h2>
      <section className="button-section">
        <button 
         onClick={handleTestButtonClick}>
          Test[Full value change]
        </button>
        <label>TEST  max std:</label>
        <input type="text" 
                placeholder='num of studies' 
                value={maxStudies}
                onChange={handleNumStdChanged} />
      </section>
      <section>
      <table className="numeric-table">
      <thead>
        <tr key={'h'}>
          <th scope="col"></th>
          <th scope="col">Patient ID</th>
          <th scope="col">Patient Name</th>
          <th scope="col">Study Date</th>
          <th scope="col">Report Date</th>
          <th scope="col">App</th>
          <th scope="col">SubApp</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
      {data.map((report) => (
        <tr key={report.reportUID}
            data-report-uid={report.reportUID}
        >
          <th>
            <Link to='/reportview'
                  search={{
                    studyInsUid: report.studyInsUID,
                    app: report.appCode,
                    subApp: report.subAppCode,
                  }}>
              GO
            </Link>
          </th>
          <th>{report.patientID}</th>
          <td>{report.patientsName}</td>
          <td>{report.studyDateTime}</td>
          <td>{report.reportDate}</td>
          <td>{report.appCode}</td>
          <td>{report.subAppCode}</td>
          <td><a className="delete_btn" href="#">x</a></td>
        </tr>
      ))}      

      </tbody>
      <tfoot>
        <tr>
          <th scope="row"></th>
          <td></td>
          <td colSpan={6}></td>
        </tr>
      </tfoot>
    </table>
      </section>
    </>
  )
}

export default ReportList
